import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Models
import {
  ICompanyPermissionSettings,
  ICompanyPermissionSettingWorker
} from '../../interfaces/permission-settings.interfaces';

export interface IPermissionSettingsState {
  company_permission_settings: ICompanyPermissionSettings,
  company_permission_setting_workers: ICompanyPermissionSettingWorker[],
  total_all: number;
  total: number;
  loading: boolean;
  error: string | null;
}

const initialState: IPermissionSettingsState = {
  company_permission_settings: {
    is_worker_profile_edit_enabled: false,
    is_worker_rates_show_enabled: false,
    // is_anonymity_enabled: false
  },
  company_permission_setting_workers: [],
  total_all: 0,
  total: 0,
  loading: true,
  error: null
};

export const permissionSettingsSlice = createSlice({
  name: 'permission-settings',
  initialState,
  reducers: {
    getCompanyPermissionSettingsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCompanyPermissionSettingsRequestSuccess: (state, { payload: company_permission_settings }: PayloadAction<ICompanyPermissionSettings>) => {
      state.company_permission_settings = company_permission_settings;
      state.loading = false;
      state.error = null;
    },
    getCompanyPermissionSettingsRequestFailure: (state, { payload: error }: PayloadAction<string>) => {
      state.loading = false;
      state.error = error;
    },
    getCompanyPermissionWorkersRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCompanyPermissionWorkersRequestSuccess: (state, {
      payload: {
        list, isLoadMore, total, total_all
      }
    }: PayloadAction<{
      list: ICompanyPermissionSettingWorker[],
      isLoadMore: boolean,
      total: number,
      total_all: number,
    }>) => {
      state.company_permission_setting_workers = isLoadMore ? [...state.company_permission_setting_workers, ...list] : list;
      state.total_all = total_all;
      state.total = total;
      state.loading = false;
      state.error = null;
    },
    getCompanyPermissionWorkersRequestFailure: (state, { payload: error }: PayloadAction<string>) => {
      state.loading = false;
      state.error = error;
    },
    updateWorkersPermissionSettings: (state, { payload: counsellor }: PayloadAction<ICompanyPermissionSettingWorker>) => {
      state.company_permission_setting_workers = state.company_permission_setting_workers
        .map(sCounsellor => sCounsellor.id === counsellor.id ? counsellor : sCounsellor);
      state.loading = false;
      state.error = null;
    },
    clearPermissionSettings: (state) => {
      state.company_permission_settings = {
        is_worker_profile_edit_enabled: false,
        is_worker_rates_show_enabled: false,
        // is_anonymity_enabled: false
      };
      state.total_all = 0;
      state.total = 0;
      state.company_permission_setting_workers = [];
      state.loading = true;
      state.error = null;
    },
  }
});

export const PermissionSettingsSliceActions = permissionSettingsSlice.actions;
